// extracted by mini-css-extract-plugin
module.exports = {"bookPost":"book-module--book-post--3S7hb","back":"book-module--back--1y6Ih","actions":"book-module--actions--wCe6b"};